// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SectionTitle Styles */

.scl--web-component-section-title-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  gap: 36px;
}

.scl--web-component-section-label-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.scl--web-component-section-label-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 2px;
  gap: 11px;
  height: 18px;
}

.scl--web-component-section-label-text {
  font-family: var(--primary-font);
  font-style:  normal;
  font-weight:  400;
  font-size:  16px;
  line-height: 150%;
  display: flex;
  align-items: center;
  color:  #7D8187;
  flex: none;
  order: 1;
  flex-grow: 0;
}
.scl--web-component-section-left-bracket {
  width: 5px;
  height: 18px;
  position: relative;
  border: 1.5px solid #7D8187;
  border-right: 1.5px solid transparent;
  flex: none;
  order: 0;
  flex-grow: 0;
}
.scl--web-component-section-right-bracket {
  width: 5px;
  height: 18px;
  position: relative;
  border: 1.5px solid #7D8187;
  border-left: 1.5px solid transparent;
  flex: none;
  order: 2;
  flex-grow: 0;
}

.scl--web-component-section-title-text-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.scl--web-component-section-title-text {
  font-family: var(--primary-font);
  font-weight: lighter;
  font-style:  normal;
  font-size:  70px;
  line-height: 53px;
  display: flex;
  align-items: center;
  margin: 0;
  color:  #FFFFFF;
}

.scl--web-component-section-description-container {
  width: 100%;
  display: flex;
  align-items: start;
  justify-content: flex-start;
}

.scl--web-component-section-description-text {
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  display: flex;
  align-items: start;
  color: #969EAA;
  margin: 0;
  text-align: start;
}
`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/title/section/css/sectionTitle.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,QAAQ;EACR,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;EACrC,UAAU;EACV,QAAQ;EACR,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,oCAAoC;EACpC,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB","sourcesContent":["/* SectionTitle Styles */\n\n.scl--web-component-section-title-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  width: 100%;\n  gap: 36px;\n}\n\n.scl--web-component-section-label-container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.scl--web-component-section-label-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0px 2px;\n  gap: 11px;\n  height: 18px;\n}\n\n.scl--web-component-section-label-text {\n  font-family: var(--primary-font);\n  font-style:  normal;\n  font-weight:  400;\n  font-size:  16px;\n  line-height: 150%;\n  display: flex;\n  align-items: center;\n  color:  #7D8187;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n.scl--web-component-section-left-bracket {\n  width: 5px;\n  height: 18px;\n  position: relative;\n  border: 1.5px solid #7D8187;\n  border-right: 1.5px solid transparent;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n.scl--web-component-section-right-bracket {\n  width: 5px;\n  height: 18px;\n  position: relative;\n  border: 1.5px solid #7D8187;\n  border-left: 1.5px solid transparent;\n  flex: none;\n  order: 2;\n  flex-grow: 0;\n}\n\n.scl--web-component-section-title-text-container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.scl--web-component-section-title-text {\n  font-family: var(--primary-font);\n  font-weight: lighter;\n  font-style:  normal;\n  font-size:  70px;\n  line-height: 53px;\n  display: flex;\n  align-items: center;\n  margin: 0;\n  color:  #FFFFFF;\n}\n\n.scl--web-component-section-description-container {\n  width: 100%;\n  display: flex;\n  align-items: start;\n  justify-content: flex-start;\n}\n\n.scl--web-component-section-description-text {\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 30px;\n  display: flex;\n  align-items: start;\n  color: #969EAA;\n  margin: 0;\n  text-align: start;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
